<template>
  <v-card class="ml-4 mr-4 mt-4" :color="bubble_color" elevation="1">
    <v-system-bar color="primary" class="white--text" dark>
      {{itemHeader}}
      <v-spacer></v-spacer>
      <v-menu
        v-if="comment.OWN_COMMENT"
        open-on-hover
        down
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">
            mdi-information-outline
          </v-icon>
        </template>
        <v-list dense>
          <v-list-item @click="edit = true; commentText=comment.DOC_COMMENT" :disabled="edit">
            <v-list-item-icon><v-icon>mdi-playlist-edit</v-icon></v-list-item-icon>
            <v-list-item-title>Редактировать</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteComment">
            <v-list-item-icon><v-icon>mdi-delete-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Удалить</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-system-bar>
    <v-card-text class="black--text">
      <div v-if="!edit">
        {{comment.DOC_COMMENT}}
      </div>
      <v-card :color="bubble_color" v-else>
        <v-card-text>
          <v-textarea
            outlined
            auto-grow
            background-color="white"
            v-model="commentText"
            label="Правка комментария"
          >
          </v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" @click="commentText=''; edit=false" icon><v-icon>mdi-cancel</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green" icon @click="updateComment" :disabled="!commentChanged"><v-icon>mdi-check-all</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>

import { UI_SNACKBAR } from '@/store/actions/ui'
import { RCPT_CHANGE_MESSAGE, RCPT_DEL_MESSAGE } from '@/store/actions/receptures'

export default {
  name: 'configCommentCard',
  props: {
    comment: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      edit: false,
      commentText: ''
    }
  },
  computed: {
    bubble_color: {
      get: function () {
        return this.comment.OWN_COMMENT ? 'green lighten-5' : 'white'
      }
    },
    itemHeader: {
      get: function () {
        return this.comment.USR_FIO + ' ' + this.comment.CM_TIMESTAMP
      }
    },
    commentChanged: {
      get: function () {
        return this.comment.DOC_COMMENT !== this.commentText
      }
    }
  },
  methods: {
    deleteComment () {
      const params = {
        ULF_UUID: this.comment.ULF_UUID,
        CM_UUID: this.comment.CM_UUID
      }
      this.$store.dispatch(RCPT_DEL_MESSAGE, params)
        .then(() => {
          this.$store.commit(UI_SNACKBAR, { color: 'green lighten-1', text: 'Комментарий удалён успешно' })
          this.commentText = ''
        })
        .catch(err => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    },
    updateComment () {
      this.edit = false
      const params = {
        ULF_UUID: this.comment.ULF_UUID,
        DOC_COMMENT: this.commentText,
        CM_UUID: this.comment.CM_UUID
      }
      this.$store.dispatch(RCPT_CHANGE_MESSAGE, params)
        .then(() => {
          this.$store.commit(UI_SNACKBAR, { color: 'green lighten-1', text: 'Комментарий изменён успешно' })
          this.commentText = ''
        })
        .catch(err => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: err })
        })
    }
  }
}
</script>

<style scoped>

</style>
